import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  UrlTree,
} from "@angular/router";
import { UserService } from "@services/user.service";
import { Observable } from "rxjs";

declare let OneInc: unknown;

@Injectable({
  providedIn: "root",
})
export class OneIncGuestPaymentGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canActivate(): boolean | UrlTree | Observable<boolean> {
    if(typeof OneInc !== 'undefined') {
      return true;
    }
    this.router.navigate(['/make-payment']);
    return false;
  }
}
